<template>
  <form class="mt-2" id="form-modal">
    <!-- description input -->
    <div class="form-group">
      <label class="label-form">Reason<span style="color: red">*</span>:</label>
      <textarea class="form-control" style="height: 250px" v-model="reject_msg"
        placeholder="write a rejection reason here for this Lead">
      </textarea>
    </div>

    <!-- buttons -->
    <div class="form-footer text-right">
      <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">
        Close
      </button>
      <button type="button" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" class="btn btn-primary btn-sm ml-1" @click="save">
        <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
        Reject
      </button>
    </div>
  </form>
</template>
<script>
  // import Multiselect from 'vue-multiselect';
  import axios from "axios";

  export default {
    props: ["action", "formData", "pageNumber"],
    data: function () {
      return {
        isMiniLoading: false,
        reject_msg: ""
      };
    },
    created: function () {
      this.reject_msg = "";
    },
    methods: {
      save() {
        this.isMiniLoading = true;
        let msg = this.reject_msg;
        let status = this.formData.status;
        let id = this.formData.user;
        let page = this.formData.pageNumber;
        let color = this.formData.color;
        if (msg.replace(/\s/g, "").length) {
          this.reject_msg = "";
          this.$store
            .dispatch("users/changeDemoStatus", [status, id, msg])
            .then(() => {
              this.isMiniLoading = false;
              this.$toast.success("Status Changed Successfully");
            });
          window.$("#modal").modal("hide");
          this.$store.dispatch("users/getAllDemoRequests", [
            1,
            "",
            this.formData.tab,
            "",
            "",
            "",
            "",
            "",
            "",
            color ? color : "",
            this.formData.followup_filter
          ]);
        } else {
          this.isMiniLoading = false;
          this.$toast.warning("Please Fill All Required Fields");
        }
      },
    },
  };
</script>